import chevronRight from './chevronRight.png';
import chooseAmount from './chooseAmount.svg';
import mbcpLogo from './mbcpLogo.svg';
import success from './success.svg';

export const imagesBcp = {
	success,
	mbcpLogo,
	chooseAmount,
	chevronRight,
};
